import { z } from "zod/mini"

export const GeoPointLegacySchema = z.object({
	position: z.object({
		lat: z.number(),
		lng: z.number(),
	}),
})

export type GeoPointLegacy = z.infer<typeof GeoPointLegacySchema>
